import { Injectable } from "@angular/core";
import { Subject, Observable } from 'rxjs';

@Injectable()
export class ModoVisionService {
    
    modoNocturno:boolean = false;    
    modoNocturno$ = new Subject<boolean>();
    changeModoVision(modoNocturno: boolean) {
      this.modoNocturno = modoNocturno;      
      this.modoNocturno$.next(this.modoNocturno);      
    }

    getSelectedModoVision$(): Observable<Boolean>{
      return this.modoNocturno$.asObservable();
    }
}